module.exports = __webpack_public_path__ + "b35382e7192b9c8d666b542f35bb376e.pdf";